import mergeWith from 'lodash/mergeWith';
import { createReducer } from '@reduxjs/toolkit';

import { replaceArrays } from 'shared/lodash-utils';
import { setSubmissions } from 'redux/actions/submissions';
import { initialRootState } from '.';

const submissionsReducer = createReducer(initialRootState, builder => {
  builder.addCase(setSubmissions, (state, action) => {
    const newSubmissions = action.payload.reduce((acc, curr) => {
      acc[curr.id] = curr;

      return acc;
    }, {});

    mergeWith(state.models.submissions, newSubmissions, replaceArrays);
  });
});

export default submissionsReducer;
